import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupModelsComponent} from './pages/setup-models.component';
import { SearchContainerComponent } from './search-container/search-container.component';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SetupModelsService} from './setup-models.service';
import { ManageComponentsService} from '../manage-components/manage-components.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    
  ],
  declarations:
   [SetupModelsComponent, 
    SearchContainerComponent],
    providers:[SetupModelsService,
      ManageComponentsService]
})
export class SetupModelsModule { }
